I18n.translations || (I18n.translations = {});
I18n.translations["ru"] = I18n.extend((I18n.translations["ru"] || {}), {
  "actions": "Действия",
  "activemodel": {
    "errors": {
      "messages": {
        "wrong_length": {
          "few": "неверная длина (должно быть %{count} символа)",
          "many": "неверная длина (должно быть %{count} символов)",
          "one": "неверная длина (должно быть %{count} символ)",
          "other": "неверная длина (должно быть %{count} символа)"
        }
      }
    }
  },
  "activerecord": {
    "attributes": {
      "destination": {
        "adress": "Адрес",
        "name": "Название"
      },
      "employee": {
        "active": "Активен",
        "admin": "Супер-права",
        "email": "Электронная почта",
        "first_name": "Имя",
        "last_name": "Фамилия",
        "role": "Роль"
      },
      "explosive": {
        "available": "Доступно",
        "box_number": "Номер коробки",
        "code": "Код единицы",
        "delivery_date": "Дата поставки",
        "grouped_number": "Номер группы",
        "import_name": "Название импортированного файла",
        "item_number": "Номер единицы",
        "location": "Местонахождение",
        "manufacturer": "Производитель",
        "middlebox_number": "Номер упаковки",
        "number_type": "Тип номера",
        "product_name": "Название продукта",
        "product_number": "Номер продукта",
        "reason": "Причина",
        "takeout": "Выдача",
        "unknown_type": "Неизвестный тип"
      },
      "item_setting": {
        "aine_code": "Код вещества",
        "countable_unit": "Единица учёта",
        "countable_units": {
          "units": "Штуки",
          "weight": "Вес"
        },
        "include_in_waybills": "Включить в накладные",
        "item_count": "Количество единиц",
        "item_name_display": "Название на дисплее",
        "item_name_import": "Название единицы",
        "manually_created": "Создан вручную",
        "set_weight_manually": "Ручной вес",
        "uro_number": "Номер URO",
        "waybill_position": "Позиция в накладной",
        "weight": "Вес"
      },
      "log": {
        "action": "Действие",
        "actions": {
          "atgriešana": "Возврат",
          "dzēšana": "Удаление",
          "izņemšana": "Выдача",
          "korekcija": "Корректировка",
          "noliktavas pārvietošana": "Перемещение по складу",
          "pievienošana": "Добавление",
          "rediģēšana": "Редактирование",
          "saņemšana": "Поступление",
          "starp-objektu pārvietošana": "Перемещение между объектами"
        },
        "author": "Исполнитель",
        "corrected_explosives": "Исправленные взрывчатые вещества",
        "current_destination": "Текущее место",
        "date": "Дата",
        "destination": "Рабочий объект",
        "destinations": "Рабочие объекты",
        "employee": "Сотрудник",
        "id_number": "ID номер",
        "import_name": "Импортированный файл",
        "notes": "Заметки",
        "takeout": "Выдача",
        "takeout_waybill": "Накладная на выдачу",
        "takeout_waybill_custom_items": "Ручная строка накладной на выдачу",
        "vehicle": "Транспорт"
      },
      "pdf_code_printout": {
        "code": "Код",
        "name": "Название",
        "unit": "Единица измерения",
        "weight": "Вес"
      },
      "report": {
        "code": "Код",
        "name": "Название",
        "unit": "Единица измерения",
        "weight": "Вес"
      },
      "takeout": {
        "active": "Активна?",
        "date": "Дата",
        "destination": "Рабочий объект",
        "employee": "Создатель",
        "removed": "Удалена",
        "vehicle": "Транспорт",
        "waybills": "Накладные"
      },
      "takeout_waybill": {
        "date": "Дата",
        "destination": "Объект",
        "direction": "Направление",
        "employee": "Сотрудник",
        "initally_edited": "Отредактировано",
        "issuance_person": "Отправитель",
        "issuer": "Отправитель",
        "legal_entity": "Юридическое лицо",
        "number": "Номер",
        "receiver": "Получатель",
        "receiving_person": "Получатель",
        "route": "Маршрут",
        "takeout": "Выдача",
        "to_object": "На объект",
        "vehicle": "Транспорт"
      },
      "takeout_waybill_custom_item": {
        "amount": "Количество",
        "item_setting": "Настройки единицы",
        "name": "Название",
        "package_name": "Упаковка",
        "takeout_waybill": "Накладная на выдачу",
        "weight": "Вес"
      },
      "user": {
        "confirmation_sent_at": "Дата отправки подтверждения",
        "confirmation_token": "Токен подтверждения",
        "confirmed_at": "Дата подтверждения",
        "created_at": "Дата создания",
        "current_password": "Текущий пароль",
        "current_sign_in_at": "Дата текущего входа",
        "current_sign_in_ip": "IP текущего входа",
        "email": "Эл. почта",
        "encrypted_password": "Зашифрованный пароль",
        "failed_attempts": "Неудачные попытки",
        "last_sign_in_at": "Дата последнего входа",
        "last_sign_in_ip": "IP последнего входа",
        "locked_at": "Дата блокировки",
        "password": "Пароль",
        "password_confirmation": "Подтверждение пароля",
        "remember_created_at": "Дата создания запоминания",
        "remember_me": "Запомнить меня",
        "reset_password_sent_at": "Дата отправки сброса пароля",
        "reset_password_token": "Токен сброса пароля",
        "sign_in_count": "Количество входов",
        "unconfirmed_email": "Неподтверждённая эл. почта",
        "unlock_token": "Токен разблокировки",
        "updated_at": "Дата обновления"
      },
      "vehicle": {
        "active": "Активен",
        "number_plate": "Номерной знак"
      },
      "warehouse": {
        "address": "Адрес",
        "city": "Город",
        "country_code": "Код страны",
        "latitude": "Широта",
        "longitude": "Долгота",
        "name": "Название",
        "responsible_employee": "Ответственное лицо",
        "zip": "Почтовый индекс"
      }
    },
    "created_at": "Создан",
    "errors": {
      "destination": {
        "adress_taken": "Указанный адрес уже добавлен",
        "generic_error": "Ошибка во входных данных",
        "name_blank": "Название не может быть пустым"
      },
      "messages": {
        "record_invalid": "Возникли ошибки: %{errors}",
        "restrict_dependent_destroy": {
          "has_many": "Невозможно удалить запись, так как существуют зависимости: %{record}",
          "has_one": "Невозможно удалить запись, так как существует зависимость: %{record}"
        }
      },
      "takeout": {
        "employee_already_has_identical_takeout": "У сотрудника уже есть идентичная выдача",
        "missing_destinations": "Должен быть выбран хотя бы один рабочий объект"
      },
      "takeout_waybill": {
        "destination_unknown": "Hеизвестно"
      }
    },
    "models": {
      "destination": "Рабочий объект",
      "employee": "Сотрудник",
      "explosive": "Взрывчатое вещество",
      "item_setting": "Настройка единицы",
      "log": "Журнал действий",
      "pdf_code_printout": "Печать PDF-кодов",
      "report": "Отчет",
      "takeout": "Выдача взрывчатых веществ",
      "takeout_waybill": "Накладная на выдачу",
      "takeout_waybill_custom_item": "Ручной ввод единицы",
      "user": {
        "few": "Пользователя",
        "many": "Пользователей",
        "one": "Пользователь",
        "other": "Пользователей"
      },
      "vehicle": "Транспорт",
      "warehouse": "Склад"
    },
    "removed": "Удален",
    "updated_at": "Обновлен"
  },
  "auth": {
    "passwords": {
      "edit": {
        "back_to_login": "Назад к входу",
        "description": "Выберите новый пароль для своего аккаунта.",
        "password_confirmation_label": "Подтвердите новый пароль",
        "password_label": "Новый пароль",
        "submit": "Обновить пароль",
        "title": "Установить пароль"
      },
      "new": {
        "back_to_login": "Назад к входу",
        "description": "Введите рабочий email, чтобы получить ссылку для настройки пароля.",
        "submit": "Отправить ссылку",
        "title": "Запросить ссылку для смены пароля"
      }
    },
    "sessions": {
      "new": {
        "auth_divider": "или",
        "email_login_button": "Войти по e-mail",
        "email_login_description": "Используйте корпоративную почту Balrock и пароль, созданный по ссылке из приглашения.",
        "email_login_title": "Вход по электронной почте",
        "google_auth": "Войти через Google",
        "password_label": "Пароль",
        "password_link_text": "Запросить ссылку для создания или сброса пароля",
        "remember_me": "Запомнить меня",
        "title": "Войти в систему учета BALROCK склада"
      }
    }
  },
  "back": "Назад",
  "cancel": "Отменить",
  "controllers": {
    "application": {
      "not_logged_in": "Вам необходимо войти в систему, чтобы просмотреть запрашиваемую страницу!",
      "not_permitted": "У вас нет прав для просмотра запрашиваемой страницы!",
      "report_ready": "Ваш отчет: %{report_name} готов! %{link} <br>"
    },
    "auth": {
      "sessions": {
        "invalid_credentials": "Неверный email или пароль. Проверьте введенные данные.",
        "no_access": "Ваш доступ к системе запрещен. Свяжитесь с администрацией.",
        "server_error": "Произошла ошибка сервера. Попробуйте еще раз."
      }
    },
    "destinations": {
      "object_added": "Объект успешно добавлен",
      "object_edited": "Объект успешно отредактирован"
    },
    "employees": {
      "employee_added": "Сотрудник успешно добавлен",
      "employee_added_with_invite": "Сотрудник добавлен, ссылка для создания пароля отправлена",
      "employee_edited": "Данные сотрудника успешно обновлены",
      "password_email_failed": "Сотрудник добавлен, но отправить письмо со ссылкой для пароля не удалось."
    },
    "explosives": {
      "all_items_moved": "Все отмеченные единицы успешно перемещены",
      "all_items_removed": "Все единицы успешно удалены",
      "all_items_returned": "Все единицы успешно возвращены на склад",
      "database_updated": "База данных обновлена",
      "failed_import_file_count": "%{count_failed} из %{count_total} не удалось импортировать",
      "failed_to_add": "%{count} единиц не удалось добавить",
      "failed_to_import": "Не удалось импортировать файл %{filename}, потому что %{reason}",
      "import_in_progress": "Файл импортируется. О результате вам сообщат.",
      "item_already_at_destination": "уже на складе назначения",
      "item_not_found": "не найдено",
      "item_removed": "удалено",
      "item_unavailable": "недоступно",
      "multiple_warehouses": "Ошибка! Отсканированные единицы находятся в нескольких складах, уточните их номера.",
      "no_files_selected": "Файлы не выбраны",
      "no_item_settings": "Некоторые единицы не связаны с настройками",
      "no_items_found": "В указанном диапазоне номеров единицы не найдены",
      "no_warehouse": "--",
      "not_all_items_moved": "Произошла ошибка при перемещении единиц, проверьте список.",
      "not_all_states_changed": "Произошла ошибка, и статус некоторых единиц не изменился",
      "not_available_for_movement": "Единица взрывчатого вещества недоступна",
      "partial_items_moved": "Успешно перемещено %{moved} отмеченных единиц. %{failed} отмеченных единиц не удалось (напр. %{examples}).",
      "range_must_be_numeric": "Начало и конец диапазона должны быть числовыми",
      "range_required": "Введите начало и конец диапазона",
      "range_start_after_end": "Начало диапазона должно быть меньше или равно концу",
      "range_too_large": "Диапазон слишком большой (макс. %{max} единиц)",
      "warehouse_not_selected": "Склад назначения не выбран"
    },
    "item_settings": {
      "created": "Настройки единицы успешно созданы",
      "deleted": "Настройки единицы успешно удалены",
      "edited": "Настройки единицы успешно обновлены",
      "failed_to_create": "Ошибка при создании настроек единицы",
      "failed_to_edit": "Ошибка при обновлении настроек единицы",
      "unable_to_delete": "Невозможно удалить, так как связано со взрывчатыми веществами"
    },
    "reports": {
      "error": "Произошла ошибка. Пожалуйста, создайте отчет заново!",
      "no_period": "Пожалуйста, укажите период отчета о движении взрывчатых веществ!",
      "no_report": "Файл отчета не найден!",
      "preparation_error": "Произошла ошибка при подготовке отчёта %{report_name}"
    },
    "sessions": {
      "invalid_credentials": "Неверный email или пароль. Проверьте введенные данные.",
      "no_access": "Ваш доступ к системе запрещен. Свяжитесь с администрацией.",
      "server_error": "Произошла ошибка сервера. Попробуйте еще раз."
    },
    "takeout_waybills": {
      "data_updated": "Данные накладной обновлены",
      "waybill_edited": "Накладная уже отредактирована"
    },
    "takeouts": {
      "add_back_to_warehouse": "Разместите единицы обратно в правильный склад!",
      "item_not_removed": "Ошибка, не удалось удалить единицу",
      "item_removed": "Единица успешно удалена",
      "need_more_data": "Пожалуйста, уточните данные накладной",
      "no_access": "У вас нет прав доступа",
      "no_access_system_error": "В системе произошла ошибка, связанная с авторизацией ваших прав доступа",
      "scan_to_next_object_title": "Отсканируйте единицы для перевозки на %{destination}",
      "takeout_confirmation_modal_title": "Вы уверены, что хотите отправиться на %{destination} с единицами:",
      "takeout_exists": "Ошибка! Такое изъятие уже существует!",
      "takeout_unavailable": "Изъятие недоступно",
      "to_next_object_button": "Переместить на %{destination}"
    },
    "vehicles": {
      "created": "Автомобиль успешно добавлен",
      "edited": "Автомобиль успешно отредактирован"
    },
    "warehouses": {
      "unable_to_delete": "Не удалось удалить склад",
      "warehouse_created": "Склад успешно создан",
      "warehouse_deleted": "Склад успешно удален",
      "warehouse_edited": "Данные склада успешно обновлены"
    }
  },
  "create": "Создать",
  "date": {
    "abbr_day_names": [
      "Вс",
      "Пн",
      "Вт",
      "Ср",
      "Чт",
      "Пт",
      "Сб"
    ],
    "abbr_month_names": [
      null,
      "янв.",
      "февр.",
      "марта",
      "апр.",
      "мая",
      "июня",
      "июля",
      "авг.",
      "сент.",
      "окт.",
      "нояб.",
      "дек."
    ],
    "day_names": [
      "воскресенье",
      "понедельник",
      "вторник",
      "среда",
      "четверг",
      "пятница",
      "суббота"
    ],
    "formats": {
      "default": "%d.%m.%Y",
      "long": "%-d %B %Y",
      "short": "%-d %b"
    },
    "month_names": [
      null,
      "января",
      "февраля",
      "марта",
      "апреля",
      "мая",
      "июня",
      "июля",
      "августа",
      "сентября",
      "октября",
      "ноября",
      "декабря"
    ],
    "order": [
      "day",
      "month",
      "year"
    ]
  },
  "datetime": {
    "distance_in_words": {
      "about_x_hours": {
        "few": "около %{count} часов",
        "many": "около %{count} часов",
        "one": "около %{count} часа",
        "other": "около %{count} часов"
      },
      "about_x_months": {
        "few": "около %{count} месяцев",
        "many": "около %{count} месяцев",
        "one": "около %{count} месяца",
        "other": "около %{count} месяцев"
      },
      "about_x_years": {
        "few": "около %{count} лет",
        "many": "около %{count} лет",
        "one": "около %{count} года",
        "other": "около %{count} лет"
      },
      "almost_x_years": {
        "few": "почти %{count} года",
        "many": "почти %{count} лет",
        "one": "почти %{count} год",
        "other": "почти %{count} лет"
      },
      "half_a_minute": "полминуты",
      "less_than_x_minutes": {
        "few": "меньше %{count} минут",
        "many": "меньше %{count} минут",
        "one": "меньше %{count} минуты",
        "other": "меньше %{count} минут"
      },
      "less_than_x_seconds": {
        "few": "меньше %{count} секунд",
        "many": "меньше %{count} секунд",
        "one": "меньше %{count} секунды",
        "other": "меньше %{count} секунд"
      },
      "over_x_years": {
        "few": "больше %{count} лет",
        "many": "больше %{count} лет",
        "one": "больше %{count} года",
        "other": "больше %{count} лет"
      },
      "x_days": {
        "few": "%{count} дня",
        "many": "%{count} дней",
        "one": "%{count} день",
        "other": "%{count} дней"
      },
      "x_minutes": {
        "few": "%{count} минуты",
        "many": "%{count} минут",
        "one": "%{count} минута",
        "other": "%{count} минут"
      },
      "x_months": {
        "few": "%{count} месяца",
        "many": "%{count} месяцев",
        "one": "%{count} месяц",
        "other": "%{count} месяцев"
      },
      "x_seconds": {
        "few": "%{count} секунды",
        "many": "%{count} секунд",
        "one": "%{count} секунда",
        "other": "%{count} секунд"
      },
      "x_years": {
        "few": "%{count} года",
        "many": "%{count} лет",
        "one": "%{count} год",
        "other": "%{count} лет"
      }
    },
    "prompts": {
      "day": "День",
      "hour": "Час",
      "minute": "Минута",
      "month": "Месяц",
      "second": "Секунда",
      "year": "Год"
    }
  },
  "delete": "Удалить",
  "destinations": {
    "edit": {
      "title": "Редактирование объекта"
    },
    "form": {
      "adress_note": "Адрес должен быть уникальным.",
      "adress_placeholder": "Адрес объекта",
      "name_placeholder": "Название объекта"
    },
    "new": {
      "title": "Добавление нового объекта"
    }
  },
  "devise": {
    "confirmations": {
      "confirmed": "Ваш адрес эл. почты успешно подтверждён.",
      "new": {
        "resend_confirmation_instructions": "Выслать повторно письмо с активацией"
      },
      "send_instructions": "В течение нескольких минут вы получите письмо с инструкциями по подтверждению адреса эл. почты.",
      "send_paranoid_instructions": "Если ваш адрес эл. почты есть в системе, то в течение нескольких минут вы получите письмо с инструкциями по его подтверждению."
    },
    "failure": {
      "already_authenticated": "Вы уже вошли в систему.",
      "inactive": "Ваша учётная запись ещё не активирована.",
      "invalid": "%{authentication_keys} или пароль неверны.",
      "last_attempt": "У вас осталась последняя попытка ввода пароля до блокировки учётной записи.",
      "locked": "Ваша учётная запись заблокирована.",
      "not_found_in_database": "%{authentication_keys} или пароль неверны.",
      "timeout": "Ваш сеанс закончился. Пожалуйста, войдите в систему снова.",
      "unauthenticated": "Вам необходимо войти в систему или зарегистрироваться.",
      "unconfirmed": "Вы должны подтвердить вашу учётную запись."
    },
    "mailer": {
      "confirmation_instructions": {
        "action": "Активировать",
        "greeting": "Приветствуем, %{recipient}!",
        "instruction": "Вы можете активировать свою учётную запись, нажав ссылку снизу:",
        "subject": "Инструкции по подтверждению учётной записи"
      },
      "email_changed": {
        "greeting": "Здравствуйте, %{recipient}!",
        "message": "Мы пытаемся связаться с вами, чтобы сообщить, что ваш адрес электронной почты был изменён на %{email}.",
        "message_unconfirmed": "Мы пытаемся связаться с вами, чтобы сообщить, что ваш адрес электронной почты будет изменён на %{email}.",
        "subject": "Эл. адрес изменён"
      },
      "password_change": {
        "greeting": "Здравствуйте, %{recipient}!",
        "message": "Мы пытаемся связаться с вами, чтобы сообщить, что ваш пароль был изменён.",
        "subject": "Пароль изменён"
      },
      "reset_password_instructions": {
        "action": "Сменить пароль",
        "greeting": "Здравствуйте, %{recipient}!",
        "instruction": "Вы (или кто-то ещё) запросили изменение пароля. Для изменения пароля нажмите ссылку ниже:",
        "instruction_2": "Если вы не запрашивали изменение пароля – проигнорируйте это письмо.",
        "instruction_3": "Ваш пароль не изменится, пока вы не нажмёте на ссылку и не введёте новый.",
        "subject": "Инструкции по восстановлению пароля"
      },
      "unlock_instructions": {
        "action": "Разблокировать учётную запись",
        "greeting": "Здравствуйте, %{recipient}!",
        "instruction": "Нажмите по ссылке для активации учётной записи:",
        "message": "Ваша учётная запись была заблокирована в связи с превышением предела неудачных попыток входа.",
        "subject": "Инструкции по снятию блокировки учётной записи"
      }
    },
    "omniauth_callbacks": {
      "failure": "Вы не можете войти под учётной записью из %{kind}, т.к. «%{reason}».",
      "success": "Вход выполнен под учётной записью из %{kind}."
    },
    "passwords": {
      "edit": {
        "change_my_password": "Изменить мой пароль",
        "change_your_password": "Изменить пароль",
        "confirm_new_password": "Повторите новый пароль",
        "new_password": "Новый пароль"
      },
      "new": {
        "forgot_your_password": "Забыли пароль?",
        "send_me_reset_password_instructions": "Выслать новый пароль"
      },
      "no_token": "Доступ к этой странице возможен только по ссылке из письма о восстановлении пароля. Если вы пришли по такой ссылке, пожалуйста, убедитесь, что вы скопировали всю ссылку целиком.",
      "send_instructions": "В течение нескольких минут вы получите письмо с инструкциями по восстановлению пароля.",
      "send_paranoid_instructions": "Если ваш адрес эл. почты есть в системе, то в течение нескольких минут вы получите письмо с инструкциями по восстановлению пароля.",
      "updated": "Ваш пароль изменён. Теперь вы вошли в систему.",
      "updated_not_active": "Ваш пароль изменён."
    },
    "registrations": {
      "destroyed": "До свидания! Ваша учётная запись удалена. Надеемся снова увидеть вас.",
      "edit": {
        "are_you_sure": "Вы уверены?",
        "cancel_my_account": "Удалить учётную запись",
        "currently_waiting_confirmation_for_email": "Ожидается подтверждение почты: %{email}",
        "leave_blank_if_you_don_t_want_to_change_it": "оставьте поле пустым, если не хотите его менять",
        "title": "%{resource}: изменение",
        "unhappy": "Разочарованы?",
        "update": "Обновить",
        "we_need_your_current_password_to_confirm_your_changes": "введите текущий пароль для подтверждения изменений"
      },
      "new": {
        "sign_up": "Регистрация"
      },
      "signed_up": "Добро пожаловать! Вы успешно зарегистрировались.",
      "signed_up_but_inactive": "Вы успешно зарегистрированы. Однако, вы не можете войти в систему, потому что ваша учётная запись не активирована.",
      "signed_up_but_locked": "Вы успешно зарегистрированы. Однако, вы не можете войти в систему, потому что ваша учётная запись заблокирована.",
      "signed_up_but_unconfirmed": "Письмо со ссылкой для подтверждения было отправлено на ваш адрес эл. почты. Пожалуйста, перейдите по ссылке, чтобы подтвердить учётную запись.",
      "update_needs_confirmation": "Вы успешно обновили данные учетной записи, но необходимо подтвердить новый адрес эл. почты. Пожалуйста, проверьте почтовый ящик и перейдите по ссылке, чтобы закончить процедуру проверки нового адреса.",
      "updated": "Ваша учётная запись обновлена.",
      "updated_but_not_signed_in": "Ваша учётная запись обновлена, но так как пароль был изменён, необходимо войти в систему снова."
    },
    "sessions": {
      "already_signed_out": "Выход из системы уже выполнен.",
      "new": {
        "sign_in": "Войти"
      },
      "signed_in": "Вход в систему выполнен.",
      "signed_out": "Выход из системы выполнен."
    },
    "shared": {
      "links": {
        "back": "Назад",
        "didn_t_receive_confirmation_instructions": "Не получили подтверждение?",
        "didn_t_receive_unlock_instructions": "Не получили код разблокировки?",
        "forgot_your_password": "Забыли пароль?",
        "sign_in": "Войти",
        "sign_in_with_provider": "Войти с помощью: %{provider}",
        "sign_up": "Регистрация"
      },
      "minimum_password_length": {
        "few": "(минимум символов: %{count})",
        "many": "(минимум символов: %{count})",
        "one": "(минимум %{count} символ)",
        "other": "(минимум символов: %{count})"
      }
    },
    "unlocks": {
      "new": {
        "resend_unlock_instructions": "Выслать подтверждение заново"
      },
      "send_instructions": "В течение нескольких минут вы получите письмо с инструкциями по разблокировке учётной записи.",
      "send_paranoid_instructions": "Если ваша учётная запись существует, то в течение нескольких минут вы получите письмо с инструкциями по её разблокировке.",
      "unlocked": "Ваша учётная запись разблокирована. Теперь вы можете войти в систему."
    }
  },
  "download": "Скачать",
  "edit": "Редактировать",
  "edit_object": "Редактировать",
  "employees": {
    "edit": {
      "title": "Редактирование сотрудника"
    },
    "form": {
      "email_note": "Должен быть адрес @gmail.com или @balrock.lv.",
      "email_placeholder": "Введите email сотрудника",
      "first_name_note": "Имя не должно содержать цифр.",
      "first_name_placeholder": "Введите имя сотрудника",
      "last_name_note": "Фамилия не должна содержать цифр.",
      "last_name_placeholder": "Введите фамилию сотрудника"
    },
    "index": {
      "employee_enabled": "Доступ к системе",
      "subtitle": "Управление сотрудниками и доступом",
      "title": "Сотрудники"
    },
    "new": {
      "title": "Добавление нового сотрудника"
    }
  },
  "errors": {
    "format": "%{attribute} %{message}",
    "messages": {
      "accepted": "нужно подтвердить",
      "already_confirmed": "– уже подтверждено. Пожалуйста, попробуйте войти в систему",
      "blank": "не может быть пустым",
      "confirmation": "не совпадает со значением поля %{attribute}",
      "confirmation_period_expired": "– должно быть подтверждено в течение %{period}, пожалуйста, повторите запрос на подтверждение",
      "empty": "не может быть пустым",
      "equal_to": "может иметь лишь значение, равное %{count}",
      "even": "может иметь лишь четное значение",
      "exclusion": "имеет зарезервированное значение",
      "expired": "– устарело. Пожалуйста, запросите новое",
      "greater_than": "может иметь значение большее %{count}",
      "greater_than_or_equal_to": "может иметь значение большее или равное %{count}",
      "in": "должно быть в диапазоне %{count}",
      "inclusion": "имеет непредусмотренное значение",
      "invalid": "имеет неверное значение",
      "less_than": "может иметь значение меньшее чем %{count}",
      "less_than_or_equal_to": "может иметь значение меньшее или равное %{count}",
      "model_invalid": "Возникли ошибки: %{errors}",
      "not_a_number": "не является числом",
      "not_an_integer": "не является целым числом",
      "not_found": "– не найдено",
      "not_locked": "– не заблокировано",
      "not_saved": {
        "few": "%{resource}: сохранение не удалось из-за %{count} ошибок:",
        "many": "%{resource}: сохранение не удалось из-за %{count} ошибок:",
        "one": "%{resource}: сохранение не удалось из-за одной ошибки:",
        "other": "%{resource}: сохранение не удалось из-за %{count} ошибок:"
      },
      "odd": "может иметь лишь нечетное значение",
      "other_than": "должно отличаться от %{count}",
      "present": "нужно оставить пустым",
      "required": "не может отсутствовать",
      "taken": "уже существует",
      "too_long": {
        "few": "слишком большой длины (не может быть больше чем %{count} символа)",
        "many": "слишком большой длины (не может быть больше чем %{count} символов)",
        "one": "слишком большой длины (не может быть больше чем %{count} символ)",
        "other": "слишком большой длины (не может быть больше чем %{count} символа)"
      },
      "too_short": {
        "few": "недостаточной длины (не может быть меньше %{count} символов)",
        "many": "недостаточной длины (не может быть меньше %{count} символов)",
        "one": "недостаточной длины (не может быть меньше %{count} символа)",
        "other": "недостаточной длины (не может быть меньше %{count} символа)"
      },
      "wrong_length": {
        "few": "неверной длины (может быть длиной ровно %{count} символа)",
        "many": "неверной длины (может быть длиной ровно %{count} символов)",
        "one": "неверной длины (может быть длиной ровно %{count} символ)",
        "other": "неверной длины (может быть длиной ровно %{count} символа)"
      }
    },
    "template": {
      "body": "Проблемы возникли со следующими полями:",
      "header": {
        "few": "%{model}: сохранение не удалось из-за %{count} ошибок",
        "many": "%{model}: сохранение не удалось из-за %{count} ошибок",
        "one": "%{model}: сохранение не удалось из-за %{count} ошибки",
        "other": "%{model}: сохранение не удалось из-за %{count} ошибки"
      }
    }
  },
  "explosive_unit": "Единица",
  "explosives": {
    "amount_correction": {
      "no_camera_alert": "Камера недоступна!",
      "no_camera_alert_message": "Возможно, вы не дали разрешение на ее использование или отключили JavaScript.",
      "subtitle": "Отсканируйте код или введите номер и выберите дальнейшее действие",
      "title": "Коррекция количества взрывчатых веществ"
    },
    "index": {
      "title": "Ошибочные записи"
    },
    "location": {
      "removed": "-- (Удалено вручную)",
      "used": "Использовано - %{destination_name}",
      "warehouse": "Склад"
    },
    "new": {
      "drop_files": "Перетащите файлы сюда",
      "import": "Импорт",
      "upload_note": "Выберите один или несколько файлов .xml или .xlsx."
    },
    "warehouse_movement": {
      "entry_mode_label": "Режим ввода",
      "no_camera_alert": "Камера недоступна!",
      "no_camera_alert_message": "Возможно, вы не дали разрешение на ее использование или отключили JavaScript.",
      "process_range": "Обработать диапазон",
      "range_end": "Конец диапазона",
      "range_end_placeholder": "напр. 275998",
      "range_entry": "Ввод диапазона",
      "range_entry_title": "Ввод диапазона:",
      "range_start": "Начало диапазона",
      "range_start_placeholder": "напр. 275961",
      "single_entry": "Одиночный ввод",
      "subtitle": "Выберите склад, на который добавить взрывчатые вещества, затем отсканируйте код или введите номер",
      "title": "Перемещение взрывчатых веществ между складами",
      "warehouse_select_label": "Склад назначения",
      "warehouse_select_placeholder": "Выберите склад"
    }
  },
  "helpers": {
    "select": {
      "prompt": "Выберите: "
    },
    "submit": {
      "create": "Создать %{model}",
      "submit": "Сохранить %{model}",
      "update": "Сохранить %{model}"
    }
  },
  "i18n": {
    "plural": {
      "keys": [
        "one",
        "few",
        "many",
        "other"
      ],
      "rule": "#<Proc:0x00007fc57e613618 /usr/local/bundle/gems/rails-i18n-7.0.10/lib/rails_i18n/common_pluralizations/east_slavic.rb:15 (lambda)>"
    },
    "transliterate": {
      "rule": "#<Proc:0x00007fc57e60f798 /usr/local/bundle/gems/rails-i18n-7.0.10/lib/rails_i18n/transliteration.rb:113 (lambda)>"
    }
  },
  "item_settings": {
    "index": {
      "subtitle": "Настройки веса и накладных для единиц",
      "title": "Настройки единиц"
    },
    "item_setting_row": {
      "weight_note": "Вес по умолчанию"
    }
  },
  "javascript": {
    "alert_modal": {
      "error": "Ошибка!"
    },
    "correction_code_scanner": {
      "camera_alert": "Камера недоступна!",
      "correction_modal_title": "Коррекция количества",
      "explosive_type": "Взрывчатое вещество",
      "explosive_units": "единиц",
      "no_camera_permission": "Возможно, вы не дали разрешение на ее использование или отключили JavaScript.",
      "remove_explosives": "Удалить со склада",
      "revive_explosives": "Вернуть в учёт (без склада)",
      "some_units_deleted": "но некоторые из них уже были удалены.",
      "which_has": ", в котором есть "
    },
    "file_upload": {
      "files_selected": " файлов выбрано",
      "import_notification": "Данные импортируются, пожалуйста подождите."
    },
    "item_settings": {
      "success": "Все прошло успешно"
    },
    "loading_screen": {
      "please_wait": "Пожалуйста, подождите..."
    },
    "takeout_code_scanner": {
      "add_range_items": "Добавить выбранные единицы",
      "already_scanned": "Код уже отсканирован",
      "camera_off": "Камера выключена!",
      "confirm_scanned_items": "Подтверждаю, что отсканированные единицы и их статус соответствуют действительности",
      "confirm_used_items": "Подтверждаю, что все выданные единицы были использованы на объекте",
      "error_occurred": "Произошла ошибка",
      "failed_to_remove_item": "Ошибка при удалении единицы. Попробуйте еще раз или свяжитесь с администратором!",
      "item_already_scanned": "Единица(ы) уже отсканирована(ы).",
      "item_returnable": "Подлежит возврату",
      "item_used": "Использовано",
      "items_return_confirmation": "Вы хотите вернуть следующие единицы?",
      "items_take_confirmation": "Вы хотите выдать следующие единицы?",
      "no_items_scanned": "Единицы не отсканированы",
      "range_modal_title": "Добавить единицы из диапазона",
      "refresh_for_camera": "Чтобы снова включить камеру, обновите страницу!",
      "return_scanned": "Отсканированные единицы будут считаться возвращенными на склад.",
      "scan_returnable_items": "Сканирование возвращаемых единиц",
      "scan_used_items": "Режим сканирования использованных единиц",
      "writeoff_scanned": "Отсканированные единицы будут считаться использованными на объекте. !! Все выданные единицы в той же упаковке, что и отсканированная, будут возвращены !!"
    },
    "warehouse_movement": {
      "confirm_move": "Подтвердить перемещение",
      "current_warehouse_name": "Склад",
      "explosive_type": "Взрывчатое вещество",
      "explosive_units": "единиц",
      "from_warehouse": "Со склада %{warehouse}",
      "included_ids": "Включённые ID (%{included} / %{total})",
      "items_badge": "%{count} единиц",
      "modal_title": "Перемещение взрывчатых веществ между складами",
      "modal_title_short": "Перемещение взрывчатых веществ",
      "move_error": "Произошла ошибка при перемещении единиц, проверьте список.",
      "move_success": "Взрывчатые вещества успешно перемещены",
      "move_to_button": "Переместить",
      "move_warehouse_info": "Переместить из #{from} в #{to}",
      "no_items_found": "В указанном диапазоне номеров единицы не найдены",
      "no_items_selected": "Выберите хотя бы одну единицу для перемещения",
      "range_failures_preview": "%{count} единиц нельзя переместить (напр. %{examples}).",
      "range_label": "Диапазон: %{start} → %{end}",
      "range_must_be_numeric": "Начало и конец диапазона должны быть числовыми",
      "range_required": "Введите начало и конец диапазона",
      "range_start_after_end": "Начало диапазона должно быть меньше или равно концу",
      "some_units_deleted": "но некоторые из них уже были удалены.",
      "subtitle_range": "Выберите склад назначения, затем введите или отсканируйте диапазон номеров",
      "to_warehouse": "На склад %{warehouse}",
      "total_items": "%{count} единиц",
      "total_weight": "%{weight} кг",
      "warehouse_not_selected": "Склад назначения не выбран",
      "which_has": ", в котором есть "
    }
  },
  "layouts": {
    "alert_modal": {
      "confirm": "Понял",
      "title": "Ошибка!"
    },
    "application": {
      "title": "Учет склада Balrock"
    },
    "camera_switch": {
      "use_camera": "Использовать камеру"
    },
    "confirmation_modal": {
      "confirm": "Подтвердить",
      "confirmation": "Вы использовали все выданные единицы?",
      "title": "Подтверждение"
    },
    "delete_modal": {
      "confirmation": "Вы уверены, что хотите удалить %{deletable_object}?",
      "title": "Подтверждение удаления"
    },
    "external_scanner": {
      "item_number_placeholder": "Ручной ввод номера",
      "search": "Поиск",
      "title": "Ручной ввод или сканирование внешним сканером:"
    },
    "loading_overlay": {
      "please_wait": "Пожалуйста, подождите..."
    },
    "sidebar": {
      "additional_code_printouts": "Печать дополнительных кодов",
      "back": "Назад",
      "correction": "Коррекция количества",
      "home": "Главная страница",
      "language": "Язык",
      "logout": "Выйти",
      "logs": "Список событий",
      "menu": "Меню",
      "receive_explosives": "Прием",
      "reports": "Отчеты",
      "return": "Возврат",
      "settings": {
        "destinations": "Объекты",
        "employees": "Сотрудники",
        "item_settings": "Настройки единиц",
        "title": "Настройки",
        "vehicles": "Транспорт"
      },
      "takeout": "Выдача",
      "title": "Склад взрывчатых веществ Balrock",
      "warehouse_movement": "Перемещение между складами",
      "warehouses": "Склады",
      "waybills": "Накладные"
    },
    "warehouse_selection_modal": {
      "add_consolidated_report": "Сводный отчет (все склады)",
      "description": "Пожалуйста, выберите, какие склады включить в отчет:",
      "prepare_report": "Подготовить отчет",
      "title": "Выберите склады"
    }
  },
  "logs": {
    "actions": {
      "atgriešana": "Возврат",
      "dzēšana": "Удаление",
      "izņemšana": "Выдача",
      "korekcija": "Корректировка",
      "noliktavas pārvietošana": "Перемещение по складу",
      "pievienošana": "Добавление",
      "rediģēšana": "Редактирование",
      "saņemšana": "Поступление",
      "starp-objektu pārvietošana": "Перемещение между объектами"
    },
    "corrected_explosives": {
      "corrected_amount": "Количество откорректированных единиц:",
      "corrected_explosives_table": "Откорректированные взрывчатые вещества",
      "correction_action": "Действие по корректировке:",
      "correction_date": "Дата:",
      "deletion": "❌ Удаление",
      "employee": "Исполнитель корректировок:",
      "return": "✅ Возврат в склад",
      "title": "Отчет по корректировкам взрывчатых веществ"
    },
    "helper_row": {
      "changes": "Изменения",
      "corrected_explosives_count": "Количество откорректированных взрывчатых веществ",
      "correction_action": "Действие корректировки",
      "deletion": "Удаление",
      "edited": "Отредактировано",
      "edited_object": "Отредактированный объект",
      "error": "Что-то пошло не так",
      "imported_explosives_count": "Количество добавленных взрывчатых веществ",
      "moved_between": "Перемещено между",
      "moved_explosives_count": "Количество перемещенных единиц",
      "movement_route": "Маршрут перемещения",
      "precise_time": "Точное время",
      "return": "Возврат в склад",
      "returned_explosives_count": "Количество возвращенных взрывчатых веществ",
      "taken_explosives_count": "Количество выданных взрывчатых веществ",
      "takeout_responsible_employee": "Ответственный за выдачу (создатель)",
      "to_overview": "К обзору",
      "used_explosives_count": "Количество использованных взрывчатых веществ",
      "used_explosives_weight": "Масса использованных взрывчатых веществ"
    },
    "index": {
      "filtering": "Фильтр",
      "subtitle": "События отсортированы в убывающем порядке по времени",
      "title": "Журнал действий"
    },
    "log_querry": {
      "clear_filters": "Очистить фильтры",
      "filter": "Фильтровать"
    },
    "log_table": {
      "no_results": "По заданным критериям ничего не найдено"
    },
    "warehouse_moved_explosives": {
      "employee": "Переместил:",
      "moved_between": "Перемещено между",
      "moved_explosives_count": "Количество перемещенных единиц",
      "moved_explosives_table": "Перемещенные взрывчатые вещества",
      "movement_date": "Дата:",
      "title": "Перемещение взрывчатых веществ между складами"
    }
  },
  "main": {
    "index": {
      "active_takeouts": "Активные выдачи взрывчатых веществ:",
      "current_employee": "Пользователь:",
      "employee_admin": "Администратор",
      "employee_regular": "Сотрудник",
      "employee_role": "Статус:",
      "explosives_in_warehouse": "Количество взрывчатых веществ на складе:",
      "no_actions": "Вы еще не совершили никаких действий.",
      "previous_actions": "Ваши последние действия:",
      "title": "Учет взрывчатых веществ Balrock"
    }
  },
  "new_object": "Добавить",
  "number": {
    "currency": {
      "format": {
        "delimiter": " ",
        "format": "%n %u",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "руб."
      }
    },
    "format": {
      "delimiter": " ",
      "precision": 3,
      "round_mode": "default",
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": false
    },
    "human": {
      "decimal_units": {
        "format": "%n %u",
        "units": {
          "billion": {
            "few": "Миллиарда",
            "many": "Миллиардов",
            "one": "Миллиард",
            "other": "Миллиарда"
          },
          "million": {
            "few": "Миллиона",
            "many": "Миллионов",
            "one": "Миллион",
            "other": "Миллиона"
          },
          "quadrillion": {
            "few": "Квадриллиона",
            "many": "Квадриллионов",
            "one": "Квадриллион",
            "other": "Квадриллиона"
          },
          "thousand": {
            "few": "Тысячи",
            "many": "Тысяч",
            "one": "Тысяча",
            "other": "Тысячи"
          },
          "trillion": {
            "few": "Триллиона",
            "many": "Триллионов",
            "one": "Триллион",
            "other": "Триллиона"
          },
          "unit": {
            "few": "",
            "many": "",
            "one": "",
            "other": ""
          }
        }
      },
      "format": {
        "delimiter": "",
        "precision": 1,
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "few": "байта",
            "many": "байт",
            "one": "байт",
            "other": "байта"
          },
          "eb": "ЭБ",
          "gb": "ГБ",
          "kb": "КБ",
          "mb": "МБ",
          "pb": "ПБ",
          "tb": "ТБ"
        }
      }
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%"
      }
    },
    "precision": {
      "format": {
        "delimiter": ""
      }
    }
  },
  "pagy": {
    "combo_nav_js": "Страница %{page_input} из %{pages}",
    "info": {
      "multiple_pages": "Отображаются %{item_name} <b>%{from}-%{to}</b> из <b>%{count}</b> всего",
      "no_items": "%{item_name} не найдено",
      "single_page": "Отображается <b>%{count}</b> %{item_name}"
    },
    "item_name": {
      "one": "Запись",
      "other": "Записи"
    },
    "items_selector_js": "Включить на страницу %{items_input} %{item_name}",
    "nav": {
      "gap": "&hellip;",
      "next": "Следующая&nbsp;&rsaquo;",
      "prev": "&lsaquo;&nbsp;Предыдущая"
    }
  },
  "pdf_code_printouts": {
    "generator": {
      "generation_failed": "Не удалось создать печатные коды",
      "invalid_code_type": "Неверный тип кода единицы"
    },
    "index": {
      "no_results": "Ничего не найдено",
      "package_search": "Поиск ящиков по названию для печати кодов",
      "package_search_placeholder": "Название или его часть",
      "search": "Поиск",
      "title": "Печать дубликатов кодов единиц"
    },
    "table_row": {
      "get_pdf": "Получить PDF страницу с кодами"
    }
  },
  "remove": "Убрать",
  "reports": {
    "index": {
      "available_explosives_count": "В настоящее время доступны %{count} единиц",
      "available_explosives_report": "Доступные взрывчатые вещества",
      "date_range": "Период",
      "explosive_movement_report": "Движение взрывчатых веществ за период",
      "explosive_summary": "Остатки взрывчатых веществ на складе по названию",
      "explosives_in_warehouse": "На складе находятся следующие единицы:",
      "prepare_report": "Подготовить",
      "quick_report_tab": {
        "units": "шт.",
        "weight_unit": "кг"
      },
      "tab_all": "Все",
      "tab_without_warehouse": "Без склада",
      "title": "Доступные системные отчеты в формате .xlsx",
      "total_amount": "Всего:"
    },
    "xlsx": {
      "available_explosives": {
        "xlsx": {
          "axlsx": {
            "consolidated_headers": [
              "Код",
              "Производитель",
              "Название",
              "Номер коробки",
              "Номер упаковки",
              "Номер единицы",
              "Номер URO",
              "Код AINE",
              "Файл импорта",
              "Местоположение",
              "Ответственный"
            ],
            "no_employee": "У единицы нет ответственного",
            "report_row_title": "Отчет о доступных взрывчатых веществах %{date}",
            "report_warehouse_row_title": "Отчет о доступных взрывчатых веществах на складе %{warehouse} - %{date}",
            "warehouse_headers": [
              "Код",
              "Производитель",
              "Название",
              "Номер коробки",
              "Номер упаковки",
              "Номер единицы",
              "Номер URO",
              "Код AINE",
              "Файл импорта",
              "Ответственный"
            ],
            "worksheet_title": "Доступные взрывчатые вещества"
          }
        }
      },
      "explosive_movement": {
        "xlsx": {
          "axlsx": {
            "sheet_name": {
              "active": "АктивнаяВыдача-%{index}-%{date}",
              "returned": "ВозвращеннаяВыдача-%{index}-%{date}"
            },
            "states": {
              "active": "выдана",
              "returned": "возвращена",
              "used": "использована"
            },
            "takeout_explosives_headers": [
              "Код",
              "Название",
              "Коробка",
              "Упаковка",
              "Взрывчатое вещество",
              "Файл импорта",
              "Статус"
            ],
            "takeout_info_headers": [
              "Сотрудник",
              "Рабочий объект",
              "Транспорт",
              "Статус",
              "Количество выданных единиц",
              "Количество использованных единиц"
            ],
            "worksheet_title": "Отчет о выдаче/возврате взрывчатых веществ"
          }
        }
      }
    }
  },
  "roles": {
    "driver": "Водитель",
    "employee": "Сотрудник",
    "manager": "Менеджер"
  },
  "save": "Сохранить",
  "services": {
    "takeouts": {
      "return_explosives": {
        "all_returned": "Все единицы успешно списаны!",
        "failed_to_return": "{count} единиц не удалось вернуть.",
        "returned": "Единицы успешно возвращены!",
        "server_error": "Ошибка сервера при возврате единиц!"
      },
      "take_explosives": {
        "failed_to_take": "{count} единиц не удалось изъять.",
        "server_error": "Ошибка сервера при изъятии единиц!",
        "success": "Единицы успешно изъяты"
      },
      "type": "Взрывчатое вещество"
    }
  },
  "shared": {
    "explosives_without_warehouse_block": {
      "add_to_warehouse": "Добавить на склад",
      "expand": "Развернуть",
      "title": "Взрывчатые вещества без склада"
    }
  },
  "state": "Включено",
  "support": {
    "array": {
      "last_word_connector": " и ",
      "two_words_connector": " и ",
      "words_connector": ", "
    }
  },
  "takeout_waybills": {
    "button_title_from": "Накладная ОТ",
    "button_title_to": "Накладная К",
    "custom_item_form_row": {
      "not_included_in_waybill": "Эта единица не включена в накладную"
    },
    "edit": {
      "manual_items": "Ручной ввод единиц",
      "title": "Редактирование накладной %{number}",
      "view_waybill": "Просмотр накладной",
      "waybill_persons": "Участники накладной"
    },
    "index": {
      "subtitle": "Список всех созданных накладных",
      "title": "Накладные"
    },
    "pdf": {
      "default_packaging_type": "картонная коробка",
      "failed_to_create": "Не удалось создать накладную",
      "header": {
        "date": "Дата",
        "route": "Маршрут",
        "waybill": "Накладная",
        "waybill_nr": "НАКЛАДНАЯ №"
      },
      "item_counts": {
        "kogus": "Количество",
        "laohoidja": "Кладовщик:",
        "seeria_nr": "Взято:",
        "tagastus": "Возврат:",
        "vedaja_lohkaja": "Перевозчик/Взрывник/Мастер-взрывник:",
        "veokiri_nr": "НАКЛАДНАЯ №:"
      },
      "legal_entity": {
        "address": "Адрес",
        "reg_number": "Рег. №",
        "title": "Юридическое лицо",
        "vat_number": "№ плат. НДС"
      },
      "no_custom_item_data": "Не удалось создать накладную, так как у всех находящихся в ней единиц не указан вес",
      "sender_receiver": "Отправитель/Получатель:",
      "signatures": {
        "carrier_received": "Вещество принял перевозчик:",
        "carrier_returned": "Остаток вещества вернул перевозчик кладовщику:",
        "carrier_title": "Перевозчик:",
        "date": "Дата:",
        "issuer_title": "Лица, ответственные за выдачу товара:",
        "miner_received": "Вещество от перевозчика принял минёр:",
        "miner_returned": "Остаток вещества вернул минёр перевозчику:",
        "name": "Имя, Фамилия:",
        "name_signature_date": "имя, подпись, дата",
        "receiver_title": "Лица, ответственные за приём товара:",
        "responsible_title": "Ответственное лицо:",
        "signature": "Подпись:",
        "warehouse_keeper_issued": "Накладную составил и вещество выдал кладовщик",
        "warehouse_keeper_received": "Остаток вещества принял кладовщик:"
      },
      "table": {
        "aine_code": "Код вещества",
        "consumption": "Расход\nкг/шт./м",
        "description": "Описание",
        "name": "Наименование",
        "package_count": "Количество упаковок (шт.)",
        "packaging": "Упаковка",
        "quantity": "Количество (шт.)",
        "remainder": "Остаток\nкг/шт./м",
        "source_warehouse": "Склад",
        "substance_code": "Код вещества",
        "substance_name_description": "Наименование и описание вещества",
        "taken": "Взято\nкг/шт./м",
        "total": "Итого:",
        "total_weight": "Общий вес (кг):",
        "uro_number": "URO №",
        "weight_kg": "Вес (кг)"
      },
      "total_cargo": "Общий объём груза:",
      "transport": {
        "self_transport": "собственный транспорт",
        "type": "Вид перевозки",
        "vehicle_reg": "Рег. № транспорта"
      },
      "units": {
        "kg": "кг",
        "pcs": "шт."
      }
    },
    "table_row": {
      "to_destination": "На объект",
      "to_warehouse": "На склад"
    }
  },
  "takeouts": {
    "explosive_summary": {
      "unit": "шт."
    },
    "index": {
      "active_title": "Активные выдачи (в процессе)",
      "cta": "Нажмите на любую или создайте новую!",
      "historical_title": "Завершённые выдачи (последние 50)",
      "new_takeout": "Новая выдача",
      "no_active_takeouts": "Нет активных выдач.",
      "no_historical_takeouts": "Пока нет завершённых выдач.",
      "no_takeouts": "Пока нет никаких выдач.",
      "type": "Выдача"
    },
    "new": {
      "add_destination": "Добавить",
      "choose_destination": "Выберите рабочий объект",
      "choose_vehicle": "Выберите транспортное средство",
      "destinations": "Рабочие объекты",
      "drag_to_reorder": "Перетащите для изменения порядка",
      "mandatory_field": "Это поле обязательно для заполнения"
    },
    "returns": {
      "p_text": "Нажмите на соответствующую выдачу, чтобы выполнить возврат",
      "return": "Возврат"
    },
    "scan_between_objects_explosives": {
      "available_units_title": "Доступные единицы:"
    },
    "scan_return_explosives": {
      "remaining_units_title": "Оставшиеся единицы:",
      "title": "Списать все оставшиеся взрывчатые вещества"
    },
    "scan_takeout_explosives": {
      "title": "Выдать выбранные взрывчатые вещества"
    },
    "scanner": {
      "delete_takeout": "Удалить выдачу",
      "destination": "Объект: %{destination}",
      "item_count": "Количество единиц: %{count}",
      "no_camera_alert": "Камера недоступна",
      "no_camera_subalert": "Возможно, вы не дали разрешение на использование камеры",
      "scan_only_used_explosives": "Выбрать <strong>только</strong> единицы, использованные на объекте",
      "scanned": "Сканировано:",
      "this_takeout": "эту выдачу",
      "title": "Сканирование кодов упаковок",
      "vehicle": "Транспорт: %{vehicle}"
    },
    "show": {
      "active_takeout": "✅ - Активна",
      "date": "Дата:",
      "destination": "Рабочий объект:",
      "employee": "Ответственный за выдачу:",
      "inactive_takeout": "❌ - Неактивна/Возвращена",
      "state": "Статус:",
      "subtitle": "*Таблицу можно прокручивать по горизонтали на узких мобильных устройствах",
      "title": "Обзор выдачи/возврата взрывчатых веществ",
      "title_2": "Выданные единицы взрывчатых веществ",
      "title_3": "Использованные единицы взрывчатых веществ выделены красным",
      "vehicle": "Транспорт:"
    },
    "table": {
      "button_edit_return": "Редактировать",
      "button_return_to_warehouse": "Вернуть на склад",
      "button_take_out": "Выдать",
      "button_to_next_object": "На следующий объект",
      "items": "%{count} единиц",
      "title": "Взрывчатые вещества %{action}"
    },
    "taken_explosives": {
      "no_person": "У единицы нет ответственного",
      "person": "Выдано сотрудником: %{name}",
      "title": "Выданные единицы:",
      "unknown": "неизвестно"
    }
  },
  "time": {
    "am": "утра",
    "formats": {
      "default": "%a, %d %b %Y, %H:%M:%S %z",
      "long": "%d %B %Y, %H:%M",
      "short": "%d %b, %H:%M"
    },
    "pm": "вечера"
  },
  "vehicles": {
    "edit": {
      "title": "Редактирование транспорта"
    },
    "form": {
      "number_plate_placeholder": "AA-XXXX",
      "number_plate_small_text": "Важно соблюдать формат номерного знака"
    },
    "index": {
      "delete_modal_text": "транспортное средство %{number_plate}",
      "subtitle": "Управление транспортными средствами для перевозки взрывчатых веществ",
      "title": "Транспорт"
    },
    "new": {
      "title": "Добавление нового транспорта"
    }
  },
  "view": "Просмотреть",
  "warehouses": {
    "edit": {
      "title": "Редактирование %{warehouse_name}"
    },
    "form": {
      "country_code_hint": "Используйте код ISO 3166-1 alpha-2, напр., LV.",
      "latitude_hint": "Используйте широту, напр., 56.96130.",
      "longitude_hint": "Используйте долготу, напр., 24.12540.",
      "responsible_person_prompt": "Выберите ответственного"
    },
    "index": {
      "subtitle": "Список складов и их управление",
      "title": "Склады"
    },
    "new": {
      "title": "Добавление нового склада"
    },
    "show": {
      "details_title": "Информация о складе",
      "explosives_title": "Взрывчатые вещества на складе",
      "map_title": "Расположение на карте",
      "no_explosives": "На этом складе сейчас нет взрывчатых веществ."
    }
  }
});
I18n.translations["en"] = I18n.extend((I18n.translations["en"] || {}), {
});
I18n.translations["lv"] = I18n.extend((I18n.translations["lv"] || {}), {
});
I18n.translations["lt"] = I18n.extend((I18n.translations["lt"] || {}), {
});
I18n.translations["ee"] = I18n.extend((I18n.translations["ee"] || {}), {
});
